<template>
  <div class="business">
    <div class="top-bar">
      <span @click="backfrompopup">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${instance.name} has been successfully ${editMode ? 'updated' : 'created'}`"
      btnText="Back To Legacy Data"
      @back="backfrompopup()"
    />
    <div class="content-new">
      <div class="row">
        <div class="col-12 padding-l-n margin-t-m download-btn">
          <download-button
            onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/SalaryRegister.xlsx'"
          ></download-button>
        </div>

        <div class="col-12 padding-l-n margin-t-m">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" :params="requestParams" />
        </div>
      </div>

      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To Legacy Data "
        @back="backfrompopup()"
      ></pop-up-message>

      <bottom-action-container class="placeEnd">
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" v-on:click="backfrompopup"></btn>
            <btn :text="submitFormText" type="primary" v-on:click="submit"></btn>
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { selectMixin } from "@/mixins/selectMixin";
import { mapState, mapActions, mapGetters } from "vuex";
import * as config from "@/apis/config.js";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "addgrades",
  mixins: [selectMixin],
  props: {
    mode: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_LEGACY_DATA_UPLOAD,
      nameMaxlength: null,
      descriptionMaxlength: null,
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      toast: false,
      errmsg: "",
      showSuccessMsg: false,
      instance: {
        name: "",
        description: "",
        code: ""
      }
    };
  },
  computed: {
    ...mapState("onboard/salary_bands", {
      bandsDataAll: state => state.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/salary_grades/record",
      editMode: "onboard/salary_grades/editMode"
    }),

    submitFormText() {
      if (this.editMode) return "update";
      else return "Proceed";
    },
    requestParams() {
      return this.$route.query;
    },
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    heading() {
      if (this.editMode) {
        return "Previous Payroll Data - " + this.instance.name;
      } else {
        return "Previous Payroll Data ";
      }
    }
  },
  activated() {
    this.toast = false;
    this.setGlobalValidations();
    if (this.editMode) {
      this.instance = this.record;
    } else {
      // START PL-2044
      this.refresh();
      // END PL-2044
    }
  },
  methods: {
    ...mapActions("onboard/salary_grades/", {
      act_create: "create",
      act_update: "update",
      act_upload_template: "uploadTemplate"
    }),

    /* function to set default configuration for validation */
    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

/* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
      try {
        if (res.data && res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.showSuccessBulkUploadMsg = true;
        } else {
          this.toast = true;
          this.errmsg = res.message;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },


    /* function to hide success pop-up and go back to main grades page */
    backfrompopup() {
      this.showSuccessBulkUploadMsg = false;
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/legacyData`
      });
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.$validator.reset();
        // START PL-2044
        this.instance = {
          name: "",
          description: "",
          code: ""
        };
        // END PL-2044
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to validate form */
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },


    /* server call to create or update grades */
    async performAction() {
      try {
        if (!this.$_.isEmpty(this.instance.name)) {
          this.$root._data.isSaving = true;
          let res = null;
          if (this.editMode) {
            this.instance.name = this.instance.name.toString().trim();
            res = await this.act_update([{ data: this.instance }, this.leId]);
          } else {
            let formData = {
              name: this.instance.name.toString().trim(),
              description: this.instance.description,
              le_id: this.leId,
              code: this.instance.code
            };
            res = await this.act_create({ data: formData });
          }
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.$root._data.isSaving = false;
          }
        } else {
          this.toast = true;
          this.errmsg = "Please enter Name";
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
@import "@/scss/components/margins.scss";
.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.business {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.top-bar {
  height: 64px;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.addflexispace {
  display: flex;
}
</style>
